import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Image from 'src/components/Image'

const Styled = styled.div`
  font-family: ${({ theme }) => theme.typo.primary};
  font-weight: ${({ theme }) => theme.typo.weight.regular};
  line-height: 1.44;
  font-size: 18px;

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 2.25em 0 1em;
  }

  blockquote,
  figure,
  table,
  dl,
  hr,
  ol,
  ul,
  p {
    margin: 1.25em 0;
  }

  a {
    color: currentColor;
  }

  ul,
  ol {
  }

  figure {
    max-width: 100%;
    position: relative;
    margin: 0;

    img {
      max-width: 100%;
    }

    figcaption {
      background: rgba(0, 0, 0, 0.6);
      font-size: 14px;
      position: absolute;
      padding: 3px 10px;
      width: 100%;
      bottom: 0;
      color: white;
      left: 0;
    }
  }
`

const StyledImages = styled.div`
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 50px;
  display: grid;
  margin: 2em 0;

  > :nth-last-child(odd):not(:nth-child(n + 2)) {
    grid-column: span 2;
  }
`

const StyledEntry = styled.div``

const render = ({ content, type, attrs }, key) => {
  switch (type) {
    case 'paragraph':
      return (
        <StyledEntry
          key={key}
          as="p"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )

    case 'image':
      return (
        <StyledImages key={key}>
          {content.map((data, key) => (
            <figure key={key}>
              {data.local && (
                <Image fluid={data.local.childImageSharp.fluid} />
              )}
              {data.caption && (
                <figcaption
                  dangerouslySetInnerHTML={{ __html: data.caption }}
                />
              )}
            </figure>
          ))}
        </StyledImages>
      )

    case 'ul':
      return (
        <StyledEntry key={key} as="ul">
          {content.map(({ content }, key) => (
            <li key={key} dangerouslySetInnerHTML={{ __html: content }} />
          ))}
        </StyledEntry>
      )

    case 'ol':
      return (
        <StyledEntry key={key} as="ol">
          {content.map(({ content }, key) => (
            <li key={key} dangerouslySetInnerHTML={{ __html: content }} />
          ))}
        </StyledEntry>
      )

    default:
      return (
        <StyledEntry
          key={key}
          as={type}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )
  }
}

const normalize = content => {
  const result = []
  const group = ['ul', 'ol', 'image']

  let prev = null

  content.forEach(entry => {
    const { type } = entry

    if (group.includes(type)) {
      if (prev === type) {
        return result[result.length - 1].content.push(entry)
      }

      entry = { type, content: [entry] }
    }

    result.push(entry)
    prev = type
  })

  return result
}

const KirbyContent = props => {
  const { content, ...passProps } = props

  return <Styled {...passProps}>{normalize(content).map(render)}</Styled>
}

KirbyContent.propTypes = {
  content: PropTypes.array,
}

KirbyContent.defaultProps = {
  //
}

export default KirbyContent
